import GeneratedGlobalSignatureServiceApi from "./generated/GeneratedGlobalSignatureServiceApi"

class GlobalSignatureServiceApi extends GeneratedGlobalSignatureServiceApi {

}

export const globalSignatureServiceApi = new GlobalSignatureServiceApi()
